var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title mt-5" }, [
      _c("h3", { staticClass: "d-flex justify-content-center header" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("headers.hearing_test")) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "custom-container" }, [
      _c("div", { staticClass: "form-wrapper" }, [
        _c("div", { staticClass: "d-flex justify-content-center mt-3" }, [
          _c("span", { staticClass: "header header-4" }, [
            _vm._v(_vm._s(_vm.primaryResultText))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex justify-content-center mt-2" }, [
          _c("span", { staticClass: "header header-4" }, [
            _vm._v(_vm._s(_vm.secondaryResultText))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form row mx-md-5 pt-3 pb-5 px-3 px-md-5" }, [
          _c("form", { staticClass: "col-12", attrs: { novalidate: "" } }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "label",
                  { staticClass: "custom-label", attrs: { for: "name" } },
                  [_vm._v(_vm._s(_vm.$t("form.name")))]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.data.name,
                      expression: "form.data.name"
                    }
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.has("name") },
                  attrs: {
                    id: "name",
                    type: "text",
                    placeholder: _vm.$t("form.placeholders.name"),
                    maxlength: "255"
                  },
                  domProps: { value: _vm.form.data.name },
                  on: {
                    focus: function($event) {
                      return _vm.errors.clear("name")
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form.data, "name", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("name"),
                        expression: "errors.has('name')"
                      }
                    ],
                    staticClass: "invalid-feedback"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.errors.get("name")) +
                        "\n              "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "label",
                  { staticClass: "custom-label", attrs: { for: "email" } },
                  [_vm._v(_vm._s(_vm.$t("form.email")))]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.data.email,
                      expression: "form.data.email"
                    }
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.has("email") },
                  attrs: {
                    id: "name",
                    type: "text",
                    placeholder: _vm.$t("form.placeholders.email"),
                    maxlength: "255"
                  },
                  domProps: { value: _vm.form.data.email },
                  on: {
                    focus: function($event) {
                      return _vm.errors.clear("email")
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form.data, "email", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("email"),
                        expression: "errors.has('email')"
                      }
                    ],
                    staticClass: "invalid-feedback"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.errors.get("email")) +
                        "\n              "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12 mb-4 mb-md-0" }, [
                _c(
                  "label",
                  { staticClass: "custom-label", attrs: { for: "phone" } },
                  [_vm._v(_vm._s(_vm.$t("form.phone")))]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.data.phone,
                      expression: "form.data.phone"
                    }
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.has("phone") },
                  attrs: {
                    id: "phone",
                    type: "text",
                    placeholder: _vm.$t("form.placeholders.phone"),
                    maxlength: "16"
                  },
                  domProps: { value: _vm.form.data.phone },
                  on: {
                    focus: function($event) {
                      return _vm.errors.clear("phone")
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form.data, "phone", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("phone"),
                        expression: "errors.has('phone')"
                      }
                    ],
                    staticClass: "invalid-feedback"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.errors.get("phone")) +
                        "\n              "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _vm._m(1)
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "actions d-flex justify-content-center" }, [
          _c(
            "button",
            {
              staticClass: "button primary",
              class: { disabled: _vm.isSubmiting },
              attrs: { type: "button", disabled: _vm.isSubmiting },
              on: { click: _vm.submit }
            },
            [_vm._v(_vm._s(_vm.$t("actions.submit")))]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("span", { staticClass: "header header-4" }, [
        _vm._v("Informações de contacto")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-start" }, [
      _c("span", { staticClass: "header header-6 header-start no-margin" }, [
        _vm._v(
          "Para visualizar os resultados detalhados do seu teste auditivo preencha o formulário acima e clique no botão de submissão."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }